import {
  SET_LOADING,
  UNSET_LOADING,
  SET_RESPONSE,
  OPEN_RESPONSE_MODAL,
  CLOSE_RESPONSE_MODAL,
  ERROR,
  SET_SUCCESS_MODAL,
  SET_BENEFITS_MODAL,
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
} from "../actions/actionTypes";

const initialState = {
  loading: false,
  // error: {},
  showResponseModal: false,
  // sucess: {}
  errorMessage: "",
  successModal: {
    open: false,
    title: "",
    message: "",
  },
  setBenefitModal: false,
  showSnackbar: null,
  snackbarDuration: null,
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, loading: true };
    case UNSET_LOADING:
      return { ...state, loading: false };
    case SET_RESPONSE:
      return { ...state, response: action.payload };
    case OPEN_RESPONSE_MODAL:
      return { ...state, showResponseModal: action.payload };
    case CLOSE_RESPONSE_MODAL:
      return { ...state, showResponseModal: false, errorMessage: "" };
    case ERROR:
      return {
        ...state,
        showResponseModal: action.payload,
        errorMessage: action.data,
      };
    case SET_SUCCESS_MODAL:
      return {
        ...state,
        successModal: {
          ...state.successModal,
          ...action.payload,
        },
      };
    case SHOW_SNACKBAR:
      return {
        ...state,
        showSnackbar: true,
        errorMessage: action.message,
        snackbarDuration: action.duration,
      };
    case HIDE_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
        errorMessage: "",
        snackbarDuration: null,
      };
    case SET_BENEFITS_MODAL:
      return { ...state, setBenefitModal: action.payload };
    default:
      return state;
  }
};

export default appReducer;
